import { render, staticRenderFns } from "./NoProductsPopup.vue?vue&type=template&id=10db32e0&scoped=true&"
import script from "./NoProductsPopup.vue?vue&type=script&lang=js&"
export * from "./NoProductsPopup.vue?vue&type=script&lang=js&"
import style0 from "./NoProductsPopup.vue?vue&type=style&index=0&id=10db32e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db32e0",
  null
  
)

export default component.exports